import React, { ReactElement } from "react"
import AcButton from "~/components/atoms/AcButton"
import styled from "styled-components"

const Button = styled(AcButton)`
  font-size: 22px;
  padding: 0;
  border: 2px solid #6b6bf9;
  background-color: #ffffff;
  border-radius: 10px;
  width: 80px;
  height: 50px;

  &:focus {
    background-color: #ffffff;
    border: 2px solid #6b6bf9;
  }

  & > i {
    display: flex;
    color: #707070;
    justify-content: center;
    align-items: center;
    color: #6b6bf9;
  }

  &.off {
    border: 2px solid #${({ theme }) => theme.color};
    > .desc {
      color: #${({ theme }) => theme.color} !important;
    }
  }

  &.off > i {
    color: #${({ theme }) => theme.color} !important;
  }

  > .desc {
    font-size: 11px;
    color: #6b6bf9;
  }
`

interface Props {
  onClick?: () => void
  className?: string
  color?: string
  disabled?: boolean
  children?: ReactElement | ReactElement[]
}

export default function ToggleButton(props: Props) {
  const { className, color = "C80000", children, disabled = false, onClick } = props

  return (
    <Button theme={{ color }} className={className} onClick={onClick} disabled={disabled}>
      {children}
    </Button>
  )
}
